<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-26 22:33:18
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 01:39:17
-->
<template>
  <div class="accountant-business">
    <div class="top">
      <van-nav-bar
        title="审核"
        fixed
        left-arrow
        @click-left="$router.go(-1)"
      ></van-nav-bar>
    </div>

    <div class="content">
      <div class="statebox">
        <div
          :class="[
            detailmsg.verifyLogList && detailmsg.verifyLogList.length > 0
              ? 'title spack paddingb'
              : 'title spack',
          ]"
        >
          状态
          <div class="stateicon">
            <img :src="geticon(detailmsg.approveState)" alt="" />
          </div>
        </div>

        <div
          class="setupstyle"
          v-if="detailmsg.verifyLogList && detailmsg.verifyLogList.length > 0"
        >
          <div
            class="itemstyle"
            v-for="(item, index) in detailmsg.verifyLogList"
            :key="index"
          >
            <div class="left">
              <div :class="[index == 0 ? 'shu' : 'shu lincolor']"></div>
              <div class="yuan">
                <img
                  v-if="index == detailmsg.verifyLogList.length - 1"
                  src="@/assets/dispatch/toExamine/setupactive.png"
                  alt=""
                />
                <img
                  v-else
                  src="@/assets/dispatch/toExamine/setup.png"
                  alt=""
                />
              </div>
              <div
                :class="[
                  index == detailmsg.verifyLogList.length - 1
                    ? 'shu'
                    : 'shu lincolor',
                ]"
              ></div>
            </div>
            <div class="right">
              <div style="display: flex; align-items: center">
                <span style="margin-right: 10px">
                  {{ item.operTime }}
                </span>
                <span class="name">{{ item.operName }} </span>
                <span class="boldstyle">{{
                  item.operType == 1
                    ? "提交申请"
                    : item.operType == 2
                    ? "审核驳回"
                    : item.operType == 3
                    ? "审核通过"
                    : "再次提交"
                }}</span>
              </div>

              <div class="msgstyle" v-if="item.rejectionReason">
                {{ item.rejectionReason }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="information">
        <div class="title paddingb">基本信息</div>
        <div class="incontent">
          <div class="rowflex">
            <span>姓名:</span>
            <span>{{ detailmsg.name ? detailmsg.name : "--" }}</span>
          </div>
          <div class="rowflex">
            <span>身份证:</span>
            <span>{{ detailmsg.idNo ? detailmsg.idNo : "--" }}</span>
          </div>
          <div class="rowflex">
            <span>电话:</span>
            <span>{{ detailmsg.phone ? detailmsg.phone : "--" }}</span>
          </div>
        </div>
      </div>

      <div class="information">
        <div class="title paddingb">证件信息</div>
        <div class="incontent">
          <div class="rowflex">
            <div class="imgstyle" @click="preview(detailmsg.frontCardImg)">
              <van-image
                style="width: 100%; height: 100%"
                fit="cover"
                :src="detailmsg.frontCardImg"
              />
              <div class="jieshao">身份证正面</div>
            </div>
            <div class="imgstyle" @click="preview(detailmsg.backCardImg)">
              <van-image
                style="width: 100%; height: 100%"
                fit="cover"
                :src="detailmsg.backCardImg"
              />
              <div class="jieshao">身份证反面</div>
            </div>
            <div
              class="imgstyle"
              @click="preview(detailmsg.airworthinessCertificate)"
            >
              <van-image
                style="width: 100%; height: 100%"
                fit="cover"
                :src="detailmsg.airworthinessCertificate"
              />
              <div class="jieshao">船员适任证</div>
            </div>
            <div class="imgstyle" @click="preview(detailmsg.sign)">
              <van-image
                style="width: 100%; height: 100%"
                fit="cover"
                :src="detailmsg.sign"
              />
              <div class="jieshao">电子签名</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 80px" v-if="detailmsg.approveState == 1"></div>
    <div class="tabbarstyle" v-if="detailmsg.approveState == 1">
      <div class="but" @click="nextFun(0)">驳回</div>
      <div class="but successstyle" @click="nextFun(1)">通过</div>
    </div>

    <!-- 弹出框 -->
    <van-dialog
      v-model="show"
      :title="isshoww ? '驳回理由' : '提示'"
      :showConfirmButton="false"
    >
      <van-field
        v-show="isshoww"
        class="textboder"
        v-model="message"
        rows="5"
        autosize
        type="textarea"
        placeholder="请输入驳回理由"
      />

      <div class="textmsg" v-show="!isshoww">是否确认通过审核?</div>

      <div class="buttomstyle">
        <div class="but" @click="doing(1)">取消</div>
        <div class="but successstyle" @click="doing(2)">确认</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  verifydetail,
  verifyreject,
  verifyapprove,
} from "@/utils/network/toExamine";
import { Toast } from "vant";
import { ImagePreview } from "vant";
export default {
  name: "Examine",
  data() {
    return {
      show: false,
      isshoww: false,
      message: "",
      detailmsg: {},
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getdetail();
  },
  methods: {
    nextFun(e) {
      if (e == 0) {
        this.isshoww = true;
      } else {
        this.isshoww = false;
      }

      this.show = true;
    },
    doing(e) {
      if (e == 1) {
        this.show = false;
      } else {
        if (this.isshoww) {
          // 驳回
          if (this.message) {
            verifyreject({
              id: this.$route.query.id,
              rejectionReason: this.message,
            }).then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.message = "";
                this.show = false;
                Toast.success(res.msg);
                this.$router.go(-1);
              }
            });
          } else {
            Toast.fail("请输入驳回理由");
          }
        } else {
          // 通过
          verifyapprove({
            id: this.$route.query.id,
          }).then((res) => {
            if (res.code == 200) {
              this.message = "";
              this.show = false;
              Toast.success(res.msg);
              this.$router.go(-1);
            }
          });
        }
      }
    },
    // 请求详情
    getdetail() {
      verifydetail(this.$route.query.id).then((res) => {
        this.detailmsg = res.data;
      });
    },

    // 返回图片
    geticon(status) {
      switch (status) {
        case 1:
          return require("@/assets/dispatch/toExamine/Unaudited.png");
        case 2:
          return require("@/assets/dispatch/toExamine/Passed.png");
        case 3:
          return require("@/assets/dispatch/toExamine/Rejected.png");
      }
    },
    // 图片预览
    preview(src) {
      if (src) {
        ImagePreview([src]);
      } else {
        Toast.fail("暂无图片");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.accountant-business {
  height: 100vh;
  background-color: #eeeeee;

  .top {
    width: 100%;
    background-color: #44b1f9;
    height: 80px;
    color: #fff;
    /deep/ .van-nav-bar {
      height: 80px;
      .van-nav-bar__content {
        height: 100%;
        background: #3db0fc;
      }

      .van-icon {
        color: #ffffff;
      }
      .van-nav-bar__title {
        color: #ffffff;
        line-height: 26px;
      }
    }
  }

  .content {
    margin: 12px 16px;
    .statebox {
      background: #ffffff;
      padding: 15px 12px;
      border-radius: 4px;
    }
    .information {
      margin-top: 12px;
      background: #ffffff;
      padding: 15px 12px 0 12px;
      border-radius: 4px;
    }
  }

  .tabbarstyle {
    position: fixed;
    background: #ffffff;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 15px;
    box-shadow: 0px 2px 8px 0px rgba(19, 61, 173, 0.1);
    .but {
      width: 45%;
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #dddddd;
      box-shadow: 0px 2px 8px 0px rgba(19, 61, 173, 0.1);
      border-radius: 10px;
      color: #ffffff;
      font-size: 16px;
      font-weight: bold;
    }

    .successstyle {
      background: #3db0fc;
    }
  }
}

.title {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  text-align: LEFT;
  color: #333333;
  position: relative;

  .stateicon {
    position: absolute;
    right: 0;

    img {
      width: 47px;
      height: 20px;
    }
  }

  &::before {
    content: "";
    display: block;
    width: 4px;
    height: 14px;
    background: #3db0fc;
    margin-right: 7px;
  }
}

.paddingb {
  padding-bottom: 12px;
}

.incontent {
  .rowstyle {
    padding-top: 12px;
    border-top: 1px solid #eeeeee;
    font-size: 14px;
    .boldstyle {
      margin-left: 10px;
      font-weight: bold;
    }
  }
  .rowflex {
    border-top: 1px solid #eeeeee;
    padding: 12px 0;
    font-size: 14px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .imgstyle {
      width: 48%;
      height: 100px;
      border-radius: 10px;
      margin-bottom: 12px;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      .jieshao {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        font-size: 14px;
        padding: 5px 0;
        color: #ffffff;
        background: rgba(183, 183, 183, 0.5);
      }
    }
  }
}

// 步骤条
.setupstyle {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  border-top: 1px solid #eeeeee;
  .itemstyle {
    font-size: 14px;
    display: flex;
    align-items: stretch;

    .left {
      width: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .yuan {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        img {
          width: 15px;
          height: 15px;
          border-radius: 50%;
        }
      }

      .shu {
        width: 1px;
        flex: 1;
      }
      .lincolor {
        background: #eeeeee;
      }
    }
    .right {
      flex: 1;
      padding: 10px 0;
      .name {
        display: inline-block;
        width: 60px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .msgstyle {
      background: #f3f3f3;
      color: #666666;
      padding: 4px 7px;
      font-size: 14px;
      line-height: 20px;
      margin-top: 10px;
    }
    .boldstyle {
      font-weight: bold;
    }
  }
}

/deep/.van-dialog__header {
  background: linear-gradient(
    0deg,
    rgba(240, 249, 255, 0.16) 10%,
    rgba(68, 177, 249, 0.43) 83%
  );
}

.textboder {
  width: 90%;
  margin: 10px auto;
  border: 1px solid #eeeeee;
}

.textmsg {
  width: 90%;
  text-align: center;
  margin: 30px auto;
}

.buttomstyle {
  width: 90%;
  margin: 20px auto 20px auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .but {
    width: 45%;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #dddddd;
    box-shadow: 0px 2px 8px 0px rgba(19, 61, 173, 0.1);
    border-radius: 10px;
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
  }

  .successstyle {
    background: #3db0fc;
  }
}
</style>
import { log10 } from "core-js/core/number";
